import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';
import { createBlock } from '@wordpress/blocks';
import { plus } from '@wordpress/icons';

import { getMediaGalleryItemTemplate } from '../../_shared/media-gallery-item-defaults';

export default function ItemAppender({ clientId }) {
  const { insertBlock } = useDispatch('core/block-editor');

  // Position of the item about to be added — the demo content cycles on it so
  // repeated adds don't all land on the same image.
  const itemCount = useSelect(
    (select) =>
      select('core/block-editor').getBlock(clientId)?.innerBlocks?.length ?? 0,
    [clientId]
  );

  const onAdd = () => {
    const inner = getMediaGalleryItemTemplate(itemCount).map(([name, attrs]) =>
      createBlock(name, attrs)
    );
    insertBlock(
      createBlock('brandy/media-gallery-item', {}, inner),
      undefined,
      clientId
    );
  };

  return (
    <Button
      variant="secondary"
      icon={plus}
      onClick={onAdd}
      className="brandy-media-gallery__appender"
    >
      {__('Add item', 'brandy-blocks')}
    </Button>
  );
}
